import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Notification from '@tds/core-notification';
import Text from '@tds/core-text';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';

const Hardware = ({
  hardwareList,
  contentfulError,
  isRenewal,
  viewType,
  ratePlans,
  hardware,
  setHardware,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { hardwareHeading, hardwareNote1, hardwareNote2 },
    USERS: {
      USER_AUTHENTICATION: {
        labels: { NOTE }
      }
    }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant="error" copy="en">
          Error fetching hardware data from contentful
        </Notification>
      )}

      {!contentfulError && hardwareList && hardwareList.length > 0 && (
        <Box between={3}>
          <Heading level="h4">{hardwareHeading}</Heading>
          <Notification variant="branded" copy="en">
            <Text bold> {NOTE}</Text>
            <ul style={{ marginLeft: '1rem', listStyle: 'auto' }}>
              <li>{hardwareNote1}</li>
              <li>{hardwareNote2}</li>
            </ul>
          </Notification>
          <Table
            isRenewal={isRenewal}
            viewType={viewType}
            ratePlans={ratePlans}
            hardware={hardware}
            setHardware={setHardware}
            list={hardwareList}
            total={total}
            setTotal={setTotal}
          />
        </Box>
      )}
    </>
  );
};

Hardware.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  isRenewal: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  hardware: PropTypes.arrayOf(PropTypes.object).isRequired,
  setHardware: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Hardware;
